import React from "react";
import PageLayout from "../../components/PageLayout/PageLayout";
import OnlineTerminSection from "./Sections/OnlineTerminSection";

export default function OnlineTermin(props) {
  const { configuration } = props;

  return (
    <PageLayout
      configuration={configuration}
      title="Online Termin"
      helmetTitle="Online Termin Davos | Sportplatzgarage Gutknecht – stop+go"
      description="Online Termin bei der Sportplatzgarage Gutknecht in Davos buchen – Service und Reparatur für VW, Audi, SEAT, Škoda und CUPRA."
      path="/online-termin"
    >
      <OnlineTerminSection
        appointmentSuggestionText={configuration.appointmentSuggestionText}
        appointmentSummaryText={configuration.appointmentSummaryText}
        appointmentThanksText={configuration.appointmentThanksText}
      />
    </PageLayout>
  );
}
